import React from 'react';
import emoji from "../../icons/sunglasses.png"

function Footer() {
    return <div class="footer">
                <p class="footerText"> <img id="sunny" alt="yo" src={emoji} width="25px" length="25px"/>
                &emsp; Thanks for jamming! &emsp;&emsp;
                <img id="sunny" alt="yo" src={emoji} width="25px" length="25px"/>
                &emsp;&emsp; 054-4446706 &emsp;&emsp;
                <img id="sunny" alt="yo" src={emoji} width="25px" length="25px"/>
                &emsp;&emsp; yoavbenhur@gmail.com &emsp;
                <img id="sunny" alt="yo" src={emoji} width="25px" length="25px"/> </p>
            </div>
}

export default Footer;
